<template>
  <div class="address-card">
    <div class="row card__header">
      <span class="col-12 card__header--text">{{ addressType }}</span>
    </div>
    <div class="card__body">
      <div class="row mb-1 card__body--organization">
        <div
          class="col-6 col-md-4 col-lg-3 organization__topic topic--text-regular"
        >
          Organization Name
        </div>
        <div
          class="col-6 col-md-8 col-lg-9 organization__value value--text-bold"
        >
          {{ addressDetail.organizationName }}
        </div>
      </div>
      <div class="row mb-2 card__body--business-type-and-vat">
        <div
          class="col-6 col-md-4 col-lg-3 business-type__topic topic--text-regular"
        >
          Business Type
        </div>
        <div
          class="col-6 col-md-8 col-lg-2 business-type__value value--text-bold"
        >
          {{ businessTypeName }}
        </div>
        <div
          v-if="isShowVat"
          class="col-6 col-md-4 col-lg-2 mt-2 mt-lg-0 vat__topic topic--text-regular"
        >
          Vat (%)
        </div>
        <div
          v-if="isShowVat"
          class="col-6 col-md-8 col-lg-4 mt-2 mt-lg-0 vat__value value--text-bold"
        >
          {{ addressDetail.vatType }}
        </div>
      </div>
      <div class="row mt-1 card__body--address-and-contact">
        <div class="col-12 col-lg-5 card__body--address">
          <div class="body--address-topic">
            <div class="topic--text-medium">ADDRESS</div>
          </div>
          <div class="body--address-value">
            <div class="value--text-bold text-">
              {{ addressDetail.fullAddress }}
            </div>
          </div>
        </div>
        <div class="col-lg-7 card__body--contact">
          <div class="body--contact-topic mt-2 mt-lg-0">
            <div class="topic--text-medium">CONTACT</div>
          </div>
          <div class="row body--contact-value">
            <div class="col-12 col-sm-6 contact-email">
              <div class="topic--text-regular">Email</div>
              <div class="value--text-bold text-break">
                {{ addressDetail.email }}
              </div>
            </div>
            <div class="col-12 col-sm-3 mt-1 mt-sm-0 contact-phone">
              <div class="topic--text-regular">Phone</div>
              <div class="value--text-bold">{{ addressDetail.phone }}</div>
            </div>
            <div class="col-12 col-sm-3 mt-1 mt-sm-0 contact-fax">
              <div class="topic--text-regular">Fax</div>
              <div class="value--text-bold">{{ addressDetail.fax }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MoleculeAddressCard",
  props: {
    addressDetail: {
      type: Object,
      required: true,
    },
    addressType: {
      type: String,
      required: true,
    },
  },
  computed: {
    businessTypeName() {
      return this.addressDetail?.businessType?.businessTypeName || ""
    },
    isShowVat() {
      return this.addressType === "BILLING ADDRESS"
    },
  },
}
</script>

<style lang="scss" scoped>
.address-card {
  width: 100%;
  border: 1px solid #b9b9c3;
  border-radius: 6px;
  padding: 18px;
}

.card__header {
  margin-bottom: 18px;
}

.card__header--text {
  color: #b9b9c3;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 18px;
}

.card__body--address-and-contact {
  .card__body--address {
    display: flex;
    flex-direction: column;
    .body--address-topic {
      margin-bottom: 9px;
    }
  }
  .card__body--contact {
    display: flex;
    flex-direction: column;
    .body--contact-topic {
      margin-bottom: 9px;
    }
  }
}

.value--text-bold {
  color: #6e6b7b;
  font-weight: 600;
  font-size: 14px;
}

.topic--text-medium {
  color: #b9b9c3;
  font-weight: 500;
  font-size: 12px;
}

.topic--text-regular {
  color: #5e5873;
  font-weight: 400;
  font-size: 14px;
}
</style>
